export default __webpack_public_path__ + "static/media/anthracite.ec39cc48.jpg";